import { makeStyles } from '@material-ui/core';
import { BrandColors } from '../../constants';

export const ResponseReuseMessagePageStyles = makeStyles({
  outerBox: {
    width: '494px',
  },
  innerBox: {
    borderRadius: '2px',
    border: `solid 1px ${BrandColors.grey77}`,
    backgroundColor: BrandColors.grey95,
    marginBottom: '2rem',
  },
  button: {
    color: BrandColors.blue20,
    borderRadius: '5px',
    border: `solid 2px ${BrandColors.blue20}`,
    '&:hover': {
      backgroundColor: BrandColors.white,
    },
  },
  headingColor: {
    color: BrandColors.grey20,
  },
  subHeadingColor: {
    color: BrandColors.grey33,
  },
  pos: {
    marginTop: '1.5rem',
  },
});
